<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-23 
-->
<template>
  <div class="container">
    <div class="img-group">
      <img :src="static_img_url + 'pic/H5404.png?v=' + $store.state.imgVersion">
      <div class="desc-p">
        <p>{{'找不到页面？' | dealLanguage("Can't find the page?")}}</p>
        <p>{{'别担心，' | dealLanguage("Don't worry, return to the ")}}<span @click="goBack">{{'返回首页' | dealLanguage('homepage')}}</span>{{'带您发现更多精彩。' | dealLanguage(' to discover more exciting things.')}}</p>
        <Button type="primary" @click="goBack">{{'返回首页' | dealLanguage('Home')}}</Button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  metaInfo() {
    return {
      title: this.activityDetail.name,
    }
  },
  components: {},
  created() {},
  mounted() {},
  data() {
    return {}
  },
  computed: {
    ...mapState({
      activityDetail: (state) => state.activityDetail,
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
    }),
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'index' })
    },
  },
}
</script>
<style lang='stylus' scoped>
.container
  display flex
  flex-direction column
  align-items center
  justify-content center
  padding 0.32rem 0.32rem 1.86rem
  position relative
  min-height calc(100vh - 1.22rem)
  .img-group
    position relative
    img
      width 6.44rem
      height 2.74rem
    .desc-p
      position absolute
      top 0
      left 0
      right 0
      bottom 0
      display flex
      align-items center
      justify-content center
      flex-direction column
      font-size 0.28rem
      line-height 0.52rem
      color #333333
      span
        color #FA5A00
        &:active
          color #FF4800
      .ivu-btn-primary
        color #fff
        background-color #FA5A00
        border-color #FA5A00
        box-shadow none
        transition all 0.3s
        width 2rem
        height 0.8rem
        font-size 0.28rem
        border-radius 0.22rem
        margin-top 0.2rem
        &:active
          background-color #FF4800
          border-color #FF4800
</style>